import { FirebaseAuthentication } from "@capacitor-firebase/authentication";
import uploadGoogleAuthAccessToken from "./uploadGoogleAuthAccessToken";

export default async function loginWithGoogleForApp() {
  const result = await FirebaseAuthentication.signInWithGoogle({
    useCredentialManager: false,
  });
  let cred = result.credential;

  await uploadGoogleAuthAccessToken(cred.accessToken);
}
